import React from 'react';
import AddCol from './customIcons/AddCol';
import AddRow from './customIcons/AddRow';
import Audio from './customIcons/Audio';
import Code from './customIcons/Code';
import Cross from './customIcons/Cross';
import Discussion from './customIcons/Discussion';
import Embed from './customIcons/Embed';
import File from './customIcons/File';
import Fill from './customIcons/Fill';
import H5P from './customIcons/H5P';
import Header from './customIcons/Header';
import Iframe from './customIcons/Iframe';
import Image from './customIcons/Image';
import Likert from './customIcons/Likert';
import List from './customIcons/List';
import Numeric from './customIcons/Numeric';
import PageBreak from './customIcons/PageBreak';
import Question from './customIcons/Question';
import Quote from './customIcons/Quote';
import RemoveCol from './customIcons/RemoveCol';
import RemoveRow from './customIcons/RemoveRow';
import Sort from './customIcons/Sort';
import Table from './customIcons/Table';
import Task from './customIcons/Task';
import TaskList from './customIcons/TaskList';
import TaskListAlt from './customIcons/TaskListAlt';
import Tex from './customIcons/Tex';
import Text from './customIcons/Text';
import Video from './customIcons/Video';

const icons = {
  'add-col': AddCol,
  'add-row': AddRow,
  audio: Audio,
  code: Code,
  cross: Cross,
  discussion: Discussion,
  embed: Embed,
  embedcode: Iframe,
  embedlink: Embed,
  file: File,
  fill: Fill,
  H5P: H5P,
  header: Header,
  iframe: Iframe,
  image: Image,
  likert: Likert,
  list: List,
  numeric: Numeric,
  'page-break': PageBreak,
  question: Question,
  quote: Quote,
  'remove-col': RemoveCol,
  'remove-row': RemoveRow,
  scorm: Embed,
  sort: Sort,
  table: Table,
  task: Task,
  'task-list': TaskList,
  'task-list-alt': TaskListAlt,
  tex: Tex,
  text: Text,
  video: Video
};

const attrs = {
  height: '1em',
  width: '1em',
  fill: 'currentColor',
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  style: { verticalAlign: '-.125em' }
};

interface Props {
  icon: string;
  style?: React.CSSProperties;
}

const CustomIcon = ({ icon, style }: Props) => {
  const Icon = icons[icon];
  return Icon ? <Icon {...attrs} style={{ ...attrs.style, ...style }} /> : null;
};

export default CustomIcon;
